module.exports = __webpack_public_path__ + "static/media/token.0426f4ed.svg";